// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAQdkOOyKGu0MeJkeftwNSCIhw3v8mm5YM",
    authDomain: "laurence-portfolio.firebaseapp.com",
    projectId: "laurence-portfolio",
    storageBucket: "laurence-portfolio.firebasestorage.app",
    messagingSenderId: "679353935845",
    appId: "1:679353935845:web:27fff2a3b6cd4d1ac2b10c",
    measurementId: "G-196W5E5XQC"
  };

// 🔥 Initialize Firebase App
const app = initializeApp(firebaseConfig);

let analyticsInstance = null;

/**
 * Initialise Firebase Analytics (GA4). Under the site's opt-out model this is
 * called on load by default. Safe to call more than once.
 * @return {Promise<import("firebase/analytics").Analytics|null>} analytics
 */
export async function initAnalytics() {
  if (analyticsInstance) return analyticsInstance;
  try {
    if (await isSupported()) {
      analyticsInstance = getAnalytics(app);
    }
  } catch (error) {
    console.warn("Analytics not initialised:", error);
  }
  return analyticsInstance;
}

/**
 * Opt the visitor out of Google Analytics. Sets the GA4 `ga-disable-<id>`
 * global flag, which tells gtag.js to stop sending any data even if a
 * measurement script is present.
 */
export function disableAnalytics() {
  try {
    window[`ga-disable-${firebaseConfig.measurementId}`] = true;
  } catch {
    // window unavailable (SSR / non-browser) — nothing to disable.
  }
}

export default app;
